import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { WebsocketService } from '../websocket/websocket.service';
import { map, filter } from 'rxjs/operators';
import { WebSocketPacket } from '../../interfaces/all';

@Injectable({
	providedIn: 'root'
})
export class WsChatService {
	public messages: Subject<WebSocketPacket>;
	private msgQueue: Object = {};
	private subscribeQueue: Object = {};
	private authCb: Function;
	private isAuthed: boolean;
	public userId: string;
	private replace: boolean;
	constructor(private wsService: WebsocketService) { }

	initiate(userId) {
		if (userId === this.userId) {
			return;
		}
		if (this.messages) {
			this.replace = true;
			this.isAuthed = false;
			this.messages.complete();
		}
		this.userId = userId;
		this.messages = <Subject<WebSocketPacket>>this.wsService
			.connect()
			.pipe(map((response: MessageEvent): WebSocketPacket => {
				const data = JSON.parse(response.data);
				return data;
			}));

		this.messages
			.pipe(filter(res => {
				if (res.operation === 'authenticate') {
					if (res.items[0].success) {
						this.isAuthed = true;
						console.log('autheticate success');
						if (this.authCb) {
							this.authCb();
						}
					}
					return false;
				}

				if (res.direction === 'notification') {
					for (let i in res.items) {
						if (res.items[i].payload.featureId && (res.items[i].payload.featureId in this.subscribeQueue)) {
							this.subscribeQueue[res.items[i].payload.featureId](res);
						}
					}
					return false;
				}
				return true;
			}))
			.subscribe(
				res => {
					if (res.items[0].itemId in this.msgQueue) {
						this.msgQueue[res.items[0].itemId](res);
						delete this.msgQueue[res.items[0].itemId];
					}
				},
				err => {
					console.log('websocket err', err);
				},
				() => {
					console.log('websocket closed', this.userId);
				}
			);
	}

	initiateNoAuth(userId) {
		if (userId === this.userId) {
			return;
		}
		if (this.messages) {
			this.replace = true;
			this.isAuthed = false;
			this.messages.complete();
		}
		this.userId = userId;

		this.isAuthed = true;
		this.messages = <Subject<WebSocketPacket>>this.wsService
			.connect()
			.pipe(map((response: MessageEvent): WebSocketPacket => {
				const data = JSON.parse(response.data);
				return data;
			}));

			this.messages
			.pipe(filter(res => {
				if (this.authCb) {
					this.authCb();
				}

				if (res.direction === 'notification') {
					for (let i in res.items) {
						if (res.items[i].payload.featureId && (res.items[i].payload.featureId in this.subscribeQueue)) {
							this.subscribeQueue[res.items[i].payload.featureId](res);
						}
					}
					return false;
				}
				return true;
			}))
			.subscribe(
				res => {
					if (res.items[0].itemId in this.msgQueue) {
						this.msgQueue[res.items[0].itemId](res);
						delete this.msgQueue[res.items[0].itemId];
					}
				},
				err => {
					console.log('websocket err', err);
				},
				() => {
					console.log('websocket closed', this.userId);
				}
			);

	}

	alreadyAuthed() {
		return this.isAuthed;
	}

	sendMsg(obs) {
		for (const i of obs.data.items) {
			this.msgQueue[i.itemId] = obs.next;
		}
		this.messages.next(obs.data);
	}

	_sendMsg(data): Promise<WebSocketPacket> {
		return new Promise((resolve) => {
			this.msgQueue[data.items[0].itemId] = resolve;
			this.messages.next(data);
		});
	}

	private waitingFunc(buffer, i, totalExpect, next) {
		return (res) => {
			buffer[i] = res;
			if (buffer.length === totalExpect && !buffer.includes(undefined)) {
				next(buffer);
			}
		};
	}

	subscribeNotification(featureId, cb) {
		this.subscribeQueue[featureId] = cb;
	}

	unsubscribeNotification(featureId) {
		delete this.subscribeQueue[featureId];
	}

	sendMsgAsyc(obs) {
		let request;
		let dataBuffer = [];
		let totalLength = obs.data.length
		let wait;
		for (let i in obs.data) {
			wait = this.waitingFunc(dataBuffer, i, totalLength, obs.next)
			request = obs.data[i];
			this.sendMsg({
				data: request,
				next: wait
			})
		}
	}

	close() {
		if (this.messages) {
			this.messages.complete();
		}
		this.logout();
	}

	_checkAuth() {
		return new Promise((resolve) => {
			if (this.alreadyAuthed()) {
				return resolve;
			}
			this.authCb = resolve;
			return resolve;
		});
	}

	checkAuth(cb) {
		if (this.isAuthed) {
			return cb();
		}
		this.authCb = cb;
	}

	logout(){
		this.isAuthed = false;
		this.userId = undefined;
		
	}
}
